
define('ldsh!common/templates/confirmation_popup', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-overlay-container">\n  <div class="ed-opt-toolbar ed-modal-header">\n    <div class="ed-close-wrapper">\n      <i class="ri-close-line js-cancel" data-dismiss="modal"></i>\n    </div>\n    <h3 class="ed-modal-title">' +
((__t = ( title )) == null ? '' : __t) +
'</h3>\n  </div>\n\n  <div class="ed-opt-content ed-modal-content">\n    <p>' +
((__t = ( message )) == null ? '' : __t) +
'</p>\n  </div>\n\n  <div class="ed-opt-btnbar ed-modal-footer">\n    <button\n      data-i18n="' +
((__t = ( koButton )) == null ? '' : __t) +
'"\n      type="button"\n      class="ed-btn ed-btn-secondary-action js-cancel"\n      data-dismiss="modal"\n    ></button>\n    <button\n      data-i18n="' +
((__t = ( okButton )) == null ? '' : __t) +
'"\n      type="button"\n      class="ed-btn ed-btn-primary-action js-ok"\n    ></button>\n  </div>\n</div>\n';

}
return __p
};});

